import { Button, Dialog, DialogActions, DialogContent, type DialogProps, DialogTitle, styled } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

import { type TemplateRecord } from '../types';

const StyledDialog = styled(Dialog)`
    & .MuiDialog-paper {
        width: 500px;
    }
` as typeof Dialog;

type DeleteTemplateModalProps = DialogProps & {
    templateToDelete: TemplateRecord | null;
    handleDelete: () => void;
};

const DeleteTemplateModal = (props: DeleteTemplateModalProps) => {
    const { templateToDelete, handleDelete, onClose, ...other } = props;

    const { t } = useTranslation('templates');

    const handleClose = () => {
        onClose?.({}, 'backdropClick');
    };

    return (
        <StyledDialog onClose={handleClose} {...other}>
            <DialogTitle>{t('delete-template')}</DialogTitle>

            <DialogContent>
                {templateToDelete && (
                    <Trans i18nKey="templates:delete-template-info-message">
                        Are you sure you want to permanently delete{' '}
                        <b>{{ templateName: templateToDelete?.class_name }} </b>?
                    </Trans>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose} variant="outlined">
                    {t('cancel')}
                </Button>

                <Button variant="contained" color="error" onClick={handleDelete}>
                    {t('delete')}
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default DeleteTemplateModal;
